import React from "react";

const GameInfo = function(props)
{
    return(
        <div>
            <p className="gameInfoText"> {props.ginfo}</p>             
        </div>
    );
}
export default GameInfo;